module.exports = __webpack_public_path__ + "img/quinton.0a4a785f.svg";